import React from 'react';
import NewAiEvent from '@/src/components/events/NewAiEvent';

export const NewAiEventPage = () => {
  return <NewAiEvent />;
};